module.exports = __webpack_public_path__ + "static/media/deepinsight-logo-dark-trim.1221b9e1.png";